import React from 'react';
import { Box, Button, IconButton } from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';

/**
 * ThemeManagementHeader Component
 *
 * Header section with action buttons for:
 * - Creating new themes
 * - Preview mode toggle
 * - Refreshing data
 */
const ThemeManagementHeader = ({
  loading,
  onCreateTheme,
  onRefresh,
  hideCreateButton = false,
  hideRefreshButton = false,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
      {!hideCreateButton && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={onCreateTheme}
        >
          Create New Theme
        </Button>
      )}
      {!hideRefreshButton && (
        <Box>
          <IconButton onClick={onRefresh} disabled={loading}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default ThemeManagementHeader;
